import { Grid, Checkbox, Tooltip, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faSearch } from "@fortawesome/free-solid-svg-icons";

import { Props } from "./interfaces";
import { DeleteButton, Search, SearchContainer, InputBase, Icon, AppBar, Toolbar } from "./styles";
import HeaderPortal from "../../TableHeader/HeaderPortal";

const ReportTableHeader = ({ title, searchOptions, handleChangeSearchOptions, children }: Props) => {
  return (
    <Grid
      container
      style={{ display: "flex", flexDirection: "column", gap: "15px" }}
    >
      {/* <Typography variant={"h3"}>{title}</Typography> */}
      <HeaderPortal title={title} />
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
      >
        <Toolbar>
          {children}
          <SearchContainer>
            <Search>
              <InputBase
                startAdornment={
                  <Tooltip
                    title={searchOptions.query ? "Exact Match" : ""}
                    placement="top"
                  >
                    <Checkbox
                      disabled={!searchOptions.query}
                      checked={searchOptions.exactMatch}
                      onChange={(e) => handleChangeSearchOptions("change", "exactMatch", e.target.checked)}
                    />
                  </Tooltip>
                }
                endAdornment={
                  searchOptions.query ? (
                    <DeleteButton
                      onMouseDown={(e) => {
                        e.preventDefault();
                        handleChangeSearchOptions("reset");
                      }}
                    >
                      <Icon>
                        <FontAwesomeIcon icon={faTimes} />
                      </Icon>
                    </DeleteButton>
                  ) : (
                    <Icon>
                      <FontAwesomeIcon icon={faSearch} />
                    </Icon>
                  )
                }
                value={searchOptions.query}
                onChange={(e) => handleChangeSearchOptions("change", "query", e.target.value)}
                placeholder="Search…"
              />
            </Search>
          </SearchContainer>
        </Toolbar>
      </AppBar>
    </Grid>
  );
};

export default ReportTableHeader;
